import { useCallback } from 'react';

import type { DialogAnalyticsParams } from './types';
import { useAnalytics } from './use-analytics';

/**
 * Returns a callback which fires an editionAwareness dialog closed event
 */
export const useOnCloseDialog = (props?: DialogAnalyticsParams) => {
	const { sendAnalyticsEvent } = useAnalytics();

	return useCallback(() => {
		const { attributes } = props || {};
		sendAnalyticsEvent({
			action: 'closed',
			actionSubject: 'dialog',
			actionSubjectId: 'editionAwarenessDialog',
			attributes,
		});
	}, [sendAnalyticsEvent, props]);
};
